import UserPolicy from '@/Services/Auth/Policies/UserPolicy';
import CompanyPolicy from '@/Services/Auth/Policies/CompanyPolicy';
import ImportPolicy from '@/Services/Auth/Policies/ImportPolicy';
import StorePolicy from '@/Services/Auth/Policies/StorePolicy';
import EvaluationPolicy from '@/Services/Auth/Policies/EvaluationPolicy';
import ReviewPolicy from '@/Services/Auth/Policies/ReviewPolicy';

export default class Auth {
    user;
    policies;

    constructor(user) {
        this.user = user;
        this.policies = {
            company: CompanyPolicy,
            import: ImportPolicy,
            store: StorePolicy,
            user: UserPolicy,
            evaluation: EvaluationPolicy,
            review: ReviewPolicy,
        };
    }

    canAny(actions) {
        if (!this.user) {
            return false;
        }

        if (this.user.is_admin) {
            return true;
        }

        if (Array.isArray(actions)) {
            for (const action of actions) {
                if (typeof action === 'string') {
                    if (this.can(action)) {
                        return true;
                    }
                } else if (typeof action === 'object') {
                    if (this.can(action.action, action.model)) {
                        return true;
                    }
                }
            }

            return false;
        }

        return false;
    }

    can(action, model = null) {
        if (!this.user) {
            return false;
        }

        if (this.user.is_admin) {
            return true;
        }

        // Separate keys
        let keys = action.split('.');

        if (keys.length !== 2) {
            throw new Error(`The action must be a "model.action" pair, got "${action}"!`);
        }

        if (!Object.hasOwnProperty.call(this.policies, keys[0])) {
            throw new Error(`A policy with the key "${keys[0]}" does not exist!`);
        }

        let policy = this.policies[keys[0]];

        return policy[keys[1]](this.user, model);
    }
}
